import React, { useEffect, useState, useRef } from "react";
import Loadspinner from "../../../common/Loadspinner";
import { Modal } from "@material-ui/core";
import "react-toastify/dist/ReactToastify.css";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import SelectForm from "../../../ReusableComponents/SelectForm/SelectForm";
import * as images from "../../../constants/Images";
import PropTypes from "prop-types";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import { Decrypt2 } from "../../../helpers/Cryptography/CryptoJS";
import {
  getCommonDropdownData,
  insertUpdateKCBulkUpload,
  getKCUploadDataById,
  getHashtagsAutoComplete,
  insertNewGeneratedHashtagsInMaster,
} from "../../../helpers/API/APIEndPoints";
import moment from "moment";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import { APICall } from "../../../helpers/API/APICalls";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import AccessDetailButton from "../../../ReusableComponents/Buttons/AccessDetailButton/AccessDetailButton";
import {
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import Main from "../../../common/Main/Main";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import DeleteDialogueBox from "../../../ReusableComponents/DeleteDialogueBox/DeleteDialogueBox";
import { useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import SelectFormCreatable from "../../../ReusableComponents/SelectForm/SelectFormCreatable";
import { del, ic_broken_image } from "../../../constants/Images";
import CommonService from "../../../services/CommonService";
import { getFromEncLocalStorage, sleep } from "../../../helpers/Utils/Utils";
import SelectFormCreatableV2 from "../../../ReusableComponents/SelectForm/SelectFormCreatableV2";
import DescriptionIcon from "@mui/icons-material/Description";
import CommonConstants from "../../../constants/CommonConstants";

function CircularProgressWithLabel(props) {
  return (
    <Box position="relative" display="inline-flex" borderColor="grey">
      <CircularProgress variant="determinate" {...props} />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          style={{ fontSize: "14px", color: "white", marginLeft: "64px" }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}

export function ShowAttachment(props) {
  const [id, setId] = useState("");
  const [location, setLocation] = useState("");
  const [token, setToken] = useState("");
  const [imageData, setImageData] = useState("");
  const {
    aType,
    videoId,
    attachment,
    thumbnailId,
    fIdx,
    setFileToBeDeleted,
    setShowDeleteConfirmationModal,
    index,
    editMode,
  } = props;

  useEffect(() => {
    getData();
    downloadBlobs(attachment);
  }, []);

  const downloadBlobs = async (reqData) => {
    let resp = await CommonService.downloadBlob(reqData);
    let strarray = aType?.split("/");
    let strng = strarray?.[0];
    const renderData = getRenderData(resp, strng, props);
    setImageData(renderData);
  };

  const getData = async () => {
    if (videoId != null && videoId != "") {
      const id = getFromEncLocalStorage("accountId");
      const location = getFromEncLocalStorage("location");
      let vtoken = await CreateKnowledgeService.getVideoToken(videoId);
      setToken(vtoken);
      setId(id);
      setLocation(location);
    }
  };

  // if (!aType) {
  //   return null;
  // }

  if (videoId && attachment && aType?.startsWith("video")) {
    //let thumbnailUrl = `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/${videoId}/Thumbnails/${thumbnailId}?accessToken=${token}`;
    let videoUrl = `https://api.videoindexer.ai/${location}/Accounts/${id}/Videos/${videoId}/PlayerWidget?accessToken=${token}`;
    return (
      <Card className="col-2" style={{ top: "15px" }}>
        <p>
          <iframe
            loading="lazy"
            style={{ width: "11vw", height: "11vw" }} //  height: "var(--sidebar-width)"
            allowFullScreen
            controls
            autoplay="false"
            src={videoUrl}
            onContextMenu={(e) => e.preventDefault()}
          ></iframe>
        </p>
      </Card>
    );
  } else if (
    (aType?.startsWith("image") ||
      aType?.startsWith("video") ||
      aType?.startsWith("audio") ||
      aType?.includes("pdf") ||
      aType?.includes("xlsx") ||
      aType?.includes("docx") ||
      aType?.includes("csv") ||
      aType?.includes("spreadsheetml") ||
      aType?.includes("pptx")) &&
    (attachment?.localUrl || attachment)
  ) {
    return (
      <Card
        key={`img${fIdx}`}
        className="col-2 imgCard"
        style={{ top: "15px" }}
      >
        {aType?.startsWith("video") ? (
          <video
            src={attachment?.localUrl || attachment}
            className="gridImage"
          />
        ) : aType?.startsWith("image") ? (
          <Card.Img
            variant="top"
            src={attachment?.localUrl || attachment}
            className="gridImage"
          />
        ) : aType?.startsWith("audio") ? (
          <audio
            src={attachment?.localUrl || attachment}
            className="gridImage"
            controls
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
          ></audio>
        ) : (
          <DescriptionIcon
            style={{ fontSize: "150px", left: "12px", position: "relative" }}
          />
        )}
        <Card.Body className="imgCardBody">
          <div className="row my-1">
            <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
              <Card.Text>
                {attachment?.name || attachment?.azureFileName}
              </Card.Text>
            </div>
            <div className="col-lg-2 col-sm-2 col-xs-2">
              {editMode ? (
                ""
              ) : (
                <Button variant="outline-light" size="sm">
                  <Image
                    src={del}
                    className="delBtn"
                    onClick={() => {
                      setFileToBeDeleted({
                        file: attachment,
                        index: index,
                        input: "file",
                      });
                      setShowDeleteConfirmationModal(true);
                    }}
                  />
                </Button>
              )}
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  } else if (aType) {
    return (
      <Card className="col-2" style={{ top: "15px" }}>
        <p>{imageData}</p>
      </Card>
    );
  } else {
    return null;
  }
}
ShowAttachment.propTypes = {
  editMode: PropTypes.bool,
  aType: PropTypes.string,
  attachment: PropTypes.string,
  videoId: PropTypes.string,
  thumbnailId: PropTypes.string,
  file: PropTypes.object,
  fIdx: PropTypes.number,
  setFileToBeDeleted: PropTypes.func,
  setShowDeleteConfirmationModal: PropTypes.func,
  index: PropTypes.number,
};

const getRenderData = (resp, strng, props) => {
  let returnValue = "";
  if (strng == "image") {
    returnValue = (
      <img
        src={resp}
        style={{
          marginTop: "8px",
          border: "1px solid rgb(150,150,150)",
        }}
        onContextMenu={(e) => e.preventDefault()}
        className="card-img"
      />
    );
  } else if (
    strng == "application" ||
    strng == "text" ||
    substrng == "spreadsheetml"
  ) {
    let strarray = props.aType.split("/");
    let substrng = strarray[1];
    if (substrng == "pdf") {
      returnValue = (
        <embed
          src={resp}
          style={{ width: "37vw", height: "450px" }}
          onContextMenu={(e) => {
            e.preventDefault();
          }}
        ></embed>
      );
    } else if (substrng != "pdf" || strng != "text") {
      let docurl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURI(resp)}`;
      returnValue = (
        <embed
          src={docurl}
          style={{ width: "37vw", height: "500px", border: "none" }}
        />
      );
    }
  } else if (strng == "audio") {
    returnValue = (
      <audio
        src={resp}
        style={{ width: "37vw" }}
        controls
        controlsList="nodownload"
        onContextMenu={(e) => e.preventDefault()}
      ></audio>
    );
  }
  return returnValue;
};

const KCBulkUploadDocument = () => {
  let history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [editMode, setEditMode] = useState(false);

  let formErrorObj = {};
  let counter = -1;

  const [coeOptions, setCoeOptions] = useState([]);
  const [platformOptions, setPlatformOptions] = useState([]);
  const [aggregateOptions, setAggregateOptions] = useState([]);

  const [hashtagArray, setHashtagsArray] = useState([]);
  const [selectedhashtagArray, setSelectedHashtagsArray] = useState([]);

  const [firstToken, setToken] = useState("");
  const [attachment, setAttachment] = useState();

  const [editModeDisableButton, setEditModeDisableButton] = useState(true);
  const [showWhoCanSeeOpenModal, setWhoCanSeeCloseModal] = useState(false);
  const [globalFDPDStatus, setGlobalFDPDStatus] = useState(true);
  const [coeWhoCanSee, setCoeWhoCanSee] = useState([]);
  const [tagUser, setTagUser] = useState([]);
  const [userTypeId, setUserTypeId] = useState([]);
  const [hashTag, setHashTag] = useState([]);

  const [tagUserOptions, setTagUserOptions] = useState([]);
  const [FolderName, setFolderName] = useState("");
  const [folderId, setFolderId] = useState(0);
  const [checkIsUploadedFile, setCheckIsUploadedFile] = useState(false);
  const [isProgress, setProgress] = useState(false);
  const [progressStatus, setProgStatus] = useState(0);
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [inputFields, setInputFields] = useState([]);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] =
    useState(false);
  const [fileToBeDeleted, setFileToBeDeleted] = useState({});
  const inputFileRef = useRef();
  let state_id = { FolderId: 0 };

  const [files, setFiles] = useState([]);
  // const handleBtnClick = (e) => {
  //   inputFileRef.current.click();
  // };

  const [allowedFileTypes, setAllowedFileTypes] = useState("");
  useEffect(async () => {
    getToken();
    getCoeDropDown();
    getPlatformDropDown();
    getAggregateDropDown();
    userTagDropdown();

    const allowedImagesFileTypesLS = getFromEncLocalStorage(
      "ImageFilesValidationExtension"
    );
    const allowedVideoFileTypesLS = getFromEncLocalStorage(
      "VideoFilesValidationExtension"
    );
    const allowedDocumentFileTypesLS = getFromEncLocalStorage(
      "DocumentFilesValidationExtenstion"
    );
    if (
      allowedImagesFileTypesLS ||
      allowedVideoFileTypesLS ||
      allowedDocumentFileTypesLS
    ) {
      setAllowedFileTypes(
        [
          ...allowedImagesFileTypesLS.split(","),
          ...allowedVideoFileTypesLS.split(","),
          ...allowedDocumentFileTypesLS.split(","),
        ]
          .map((aift) => `.${aift}`)
          .join(",")
      );
    }
  }, []);

  useEffect(async () => {
    if (
      coeOptions.length > 0 &&
      platformOptions.length > 0 &&
      aggregateOptions.length > 0 &&
      tagUserOptions.length > 0
    ) {
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;

      if (state_id != "") {
        state_id = JSON.parse(state_id);
        if (state_id?.FolderId !== 0 || state_id?.FolderId != "0") {
          getKCUploadData(state_id?.FolderId);
          setFolderName(state_id?.FolderName);
          setFolderId(state_id?.FolderId);
        } else {
          history.push({ pathname: "/bulk-upload-document" });
        }
      } else {
        history.push({ pathname: "/bulk-upload-document" });
      }
    }
  }, [coeOptions, platformOptions, aggregateOptions, tagUserOptions]);

  const getToken = async () => {
    const res = await CreateKnowledgeService.firstApi();
    if (res) {
      setToken(res);
    }
  };

  const getKCUploadData = async (id) => {
    setLoading(true);
    let requestParams = { FolderId: id };
    const res = await APICall(getKCUploadDataById, requestParams);
    let newfield = [];
    let enableSubmitButton = false;
    if (res && res?.data?.length > 0) {
      if (res?.data[0]?.id != null) {
        setEditMode(true);
        let temp = [];
        let temp2 = [];
        let counter = 0;

        // let newfield = {};
        // res?.data.forEach((value) => {
        //   const sysIds = `${value["system_id"]}`;
        //   const AggreegateIds = `${value["AggreegateId"]}`;
        //   const platform_ids = `${value["platform_id"]}`;

        //   let platform_id = optionValues(platformOptions, platform_ids);
        //   let AggreegateId = optionValues(aggregateOptions, AggreegateIds);
        //   let system_id = optionValues(coeOptions, sysIds);
        //   let bulk_upload_status = value["bulk_upload_status"];
        //   let description = value["description"];
        //   let Keywords = value["Keywords"];
        //   let title = value["title"];
        //   let id = value["row_id"];
        //   let file = {
        //     file: value["attachment"],
        //     uploadedFileName: value["attachment_file_name"],
        //     attachmentFileType: value["attachment_file_type"],
        //     thumbnailId: value["thumbnailId"],
        //     videoId: value["video_id"],
        //     transcriptionData: value["transcription_data"],
        //     id: value["id"],
        //   };
        //   let fileIds = { id: value["id"] };

        //   if (
        //     bulk_upload_status == 0 ||
        //     bulk_upload_status == 2 ||
        //     bulk_upload_status == null
        //   ) {
        //     enableSubmitButton = true;
        //   }

        //   if (id in newfield) {
        //     if ("file" in newfield[id]) {
        //       let fisles = newfield[id]["file"];
        //       fisles.push(file);
        //       newfield[id]["file"] = fisles;

        //       let uploadFileIdsss = newfield[id]["fileIds"];
        //       uploadFileIdsss.push(fileIds);
        //       newfield[id]["fileIds"] = uploadFileIdsss;
        //     } else {
        //       newfield[id]["file"] = [file];
        //       newfield[id]["fileIds"] = [fileIds];
        //     }
        //   } else {
        //     newfield[id] = {
        //       aggregate: AggreegateId,
        //       bulkUploadStatus: bulk_upload_status,
        //       coe: system_id,
        //       description: description,
        //       keywords: Keywords,
        //       platform: platform_id,
        //       title: title,
        //       file: [file],
        //       fileIds: [fileIds],
        //     };
        //   }
        // });
        // const newfieldArr = Object.values(newfield);

        newfield = [];
        for (let index = 0; index < res.data.length; index++) {
          const sysIds = `${res?.data[index]?.system_id}`;
          const AggreegateIds = `${res?.data[index]?.AggreegateId}`;
          const platform_ids = `${res?.data[index]?.platform_id}`;
          if (
            res?.data[index]?.bulk_upload_status == 0 ||
            res?.data[index]?.bulk_upload_status == 2 ||
            res?.data[index]?.bulk_upload_status == null
          ) {
            enableSubmitButton = true;
          }

          newfield[res?.data[index]?.id] = {
            bulkUploadStatus: res?.data[index]?.bulk_upload_status,
            keywords: res?.data[index]?.keywords,
            title: res?.data[index]?.title,
            description: res?.data[index]?.description,
            coe: optionValues(coeOptions, sysIds),
            platform: optionValues(platformOptions, platform_ids),
            aggregate: optionValues(aggregateOptions, AggreegateIds),
            fileIds: [{ id: res?.data[index]?.id }],
            file: [
              {
                file: res?.data[index]?.attachment,
                uploadedFileName: res?.data[index]?.uploadedFileName,
                attachmentFileType: res?.data[index]?.attachment_file_type,
                thumbnailId: res?.data[index]?.thumbnailId,
                videoId: res?.data[index]?.video_id,
                transcriptionData: res?.data[index]?.transcription_data,
              },
            ],
          };
        }

        const newfieldArr = Object.values(newfield);

        if (enableSubmitButton) {
          setEnableSubmit(false);
        } else {
          setEnableSubmit(true);
        }

        // console.log(newfieldArr);
        setInputFields(newfieldArr);

        setCoeWhoCanSee(
          optionValues(coeOptions, res?.data[0]?.RestrictedCOEIds)
        );
        setUserTypeId(
          optionValues(tagUserOptions, res?.data[0]?.RestrictedUserIds)
        );
        setTagUser(optionValues(tagUserOptions, res?.data[0]?.TaggedUserIds));
        setGlobalFDPDStatus(res?.data[0]?.status == 1 ? true : false);
        // label
        let hashtagsValue = `${res?.data[0]?.hashtagName}`;

        hashtagsValue = hashtagsValue?.split(",").map((item) => {
          return { label: item };
        });

        setHashtagsArray(hashtagsValue);
      }
      setLoading(false);
      // HashtagIds: "0"; // BulkUploadFolderId: 9; // division_id: 1; // TaggedUserIds: "0";
      // AggreegateId: 0; // system_id: 0; // platform_id: 0;
      // Keywords: ""; // KnowledgeNo: null; // KnowledgeStatus: null; // KnowledgebaseId: null; // Location: null; // LocationRawData: null; // RestrictedCOEIds: "0";
      // RestrictedUserIds: "0"; // VerificationStatus: null; // attachment: ""; // attachment_file_name: null; // attachment_file_type: ""; // created_by_id: "2";
      // created_date: "2023-03-30T06:43:48.000Z"; // creator: "GTOTEST2 prosares"; // creator_profile_pic: null; // department: ""; // description: ""; // expertise_id: null;
      // expertise_name: null; // id: 19896; // isKnowledge: 1; // is_legacy_data: 0; // knowledge_creationcol: null; // nameofposition: "Consultant"; // status: 1;
      // subsystem_id: 0; // tag: null; // thumbnailId: ""; // title: ""; // transcription_data: ""; // updated_date: "2023-03-30T06:43:48.000Z"; // upvotes: null; // video_id: "";
    } else {
      console.log(res.message);
      setLoading(false);
    }
  };

  const getCoeDropDown = async () => {
    let requestParams = {
      dropdownName: "allCoeCommonDropdown",
      userId: getFromEncLocalStorage("userId"), //UserId
      // searchText: 1, // User id
    };
    setLoading(true);
    const res = await APICall(getCommonDropdownData, requestParams);

    if (res && res.data?.length > 0) {
      setCoeOptions(res.data);
      setLoading(false);
    } else {
      setCoeOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };

  const getPlatformDropDown = async () => {
    let requestParams = {
      dropdownName: "platformDropdown",
    };
    setLoading(true);
    const res = await APICall(getCommonDropdownData, requestParams);

    if (res && res.data.length > 0) {
      setPlatformOptions(res.data);
      setLoading(false);
    } else {
      setPlatformOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };

  const getAggregateDropDown = async () => {
    let requestParams = {
      dropdownName: "aggregateDropdown",
    };

    setLoading(true);
    const res = await APICall(getCommonDropdownData, requestParams);

    if (res && res.data.length > 0) {
      setAggregateOptions(res.data);
      setLoading(false);
    } else {
      setLoading(false);
      setAggregateOptions([]);
      notify(1, res.message);
    }
  };

  const userTagDropdown = async () => {
    let requestParams = {
      dropdownName: "getAllUsersDropdown",
    };
    setLoading(true);
    const res = await APICall(getCommonDropdownData, requestParams);

    if (res && res.data.length > 0) {
      setTagUserOptions(res.data);
      setLoading(false);
    } else {
      setTagUserOptions([]);
      notify(1, res.message);
      setLoading(false);
    }
  };

  const optionValues = (optionArr, data) => {
    let splitData = [];
    let getSelectedOption = [];
    if (data) {
      splitData = data?.split(",");
    }
    if (splitData.length > 0) {
      for (let index = 0; index < splitData?.length; index++) {
        const sd = splitData?.[index];
        let temp = optionArr.find((element) => element.value == sd);
        if (temp?.value) {
          getSelectedOption.push(temp);
        }
      }
    }
    return getSelectedOption;
  };

  const addFields = () => {
    // validation.
    let newfield = {
      id: 0,
      bulkUploadStatus: null,
      keywords: "",
      title: "",
      description: "",
      coe: "",
      platform: "",
      aggregate: "",
      file: [{}],
      fileIds: [],
      uploadedFileName: "",
      attachmentFileType: "",
      thumbnailId: "",
      videoId: "",
      transcriptionData: "",
    };
    setInputFields([...inputFields, newfield]);
  };

  const handleFormChange = (event, index) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;
    setInputFields(data);
  };

  const removeFields = (index) => {
    let data = [...inputFields];
    counter = counter - index;
    data.splice(index, 1);
    setInputFields(data);
  };

  const fileSelect = (event, index, fieldName) => {
    if (
      Array.from(event?.target?.files).filter(
        (f) =>
          !(
            f.type.startsWith("image") ||
            f.type.startsWith("video") ||
            f.type.includes("pdf") ||
            f.type.includes("xlsx") ||
            f.type.includes("docx") ||
            f.type.includes("csv") ||
            f.type.includes("pptx") ||
            f.type.includes("spreadsheetml") ||
            f.type.includes("audio")
          )
      ).length > 0
    ) {
      notify(1, "Only images, videos, audios and documents are allowed!");
      return;
    }

    const allowedFileTypesArr = allowedFileTypes?.split(",");
    if (allowedFileTypesArr) {
      let isExtensionAllowed = true;
      let filesToCheck = [...event?.target?.files];
      for (let index = 0; index < filesToCheck.length; index++) {
        const fileToCheck = filesToCheck[index];
        isExtensionAllowed = allowedFileTypesArr.some((ext) =>
          fileToCheck?.name?.endsWith(ext)
        );
        if (!isExtensionAllowed) break;
      }
      if (!isExtensionAllowed) {
        notify(1, `Only ${allowedFileTypesArr?.join(", ")} files are allowed!`);
        return;
      }
    }

    if (event.target.files.length > 0) {
      let filesTmp = [];
      filesTmp = [...files];
      if (!filesTmp?.[index]) {
        filesTmp[index] = { row: index, files: [] };
      }
      let count = filesTmp[index].files?.length;
      for (let i = 0; i < event?.target?.files?.length; i++) {
        const file = event?.target?.files?.[i];
        if (file) {
          filesTmp[index].files.push({
            localUrl: URL.createObjectURL(file),
            blob: file,
            fileid: `img_${count}`,
            name: file.name,
            size: file.size,
            type: file.type,
            attachmentFileType: file.type,
          });
        }
        count++;
      }
      setFiles(filesTmp);
      let data = [...inputFields];
      data[index][fieldName] = filesTmp[index].files; // event.target.files[0].name;
      setInputFields(data);
      setCheckIsUploadedFile(true);
    }
  };

  const deleteImage = async (data) => {
    const { file, index, input } = data;
    setLoading(true);
    try {
      setShowDeleteConfirmationModal(false);
      let filesTmp = [];
      filesTmp = [...files];
      let newfilesTmp = [];
      newfilesTmp = filesTmp[index]?.files?.filter((f) => f.id !== file.id);
      filesTmp[index] = { row: index, files: newfilesTmp };
      setFiles(filesTmp);
      let datas = [...inputFields];
      let newData = datas?.[index]?.file.filter(
        (f) => f.fileid !== file.fileid
      );
      datas[index][input][index] = newData;
      setInputFields(datas);
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const CloseWhoCanSeeModal = () => {
    setWhoCanSeeCloseModal(false);
  };

  const resetFunction = () => {
    // setInputFolderName("");
    // setFormErrors({});
    // formErrorObj = {};
  };

  const selectOnChange = (event, index, fieldName) => {
    let data = [...inputFields];
    data[index][fieldName] = event;
    setInputFields(data);
  };

  const onClickFunctionForm = async (event, action) => {
    if (action === "Submit") {
      // await onSubmitValidation();
      // const isEmpty = await Object.values(formErrorObj).every((x1) =>
      //   x1.every((x) => x === null || x === "" || x === undefined)
      // );

      // if (isEmpty) {
      setWhoCanSeeCloseModal(true);
      // }
    } else if (action === "Reset") {
      //   resetFunction(); // pending
    } else if (action === "Cancel") {
      history.push({ pathname: "/bulk-upload-document" });
    }
  };

  // const onSubmitValidation = () => {
  //   setFormErrors({});
  //   formErrorObj = {};

  //   formErrorObj["COE_isEmpty"] = [];
  //   formErrorObj["Aggregate_isEmpty"] = [];
  //   formErrorObj["Platform_isEmpty"] = [];

  //   formErrorObj["File_isEmpty"] = [];

  //   formErrorObj["title_isEmpty"] = [];
  //   formErrorObj["description_isEmpty"] = [];
  //   formErrorObj["keywords_isEmpty"] = [];

  //   inputFields.map((input, index) => {
  //     if (
  //       !input.coe ||
  //       Object.keys(input.coe).length <= 0 ||
  //       input.coe === ""
  //     ) {
  //       formErrorObj["COE_isEmpty"][index] = "Please Select COE";
  //     }
  //     if (
  //       !input.aggregate ||
  //       Object.keys(input.aggregate).length <= 0 ||
  //       input.aggregate === ""
  //     ) {
  //       formErrorObj["Aggregate_isEmpty"][index] = "Please Select Aggregate";
  //     }
  //     if (
  //       !input.platform ||
  //       Object.keys(input.platform).length <= 0 ||
  //       input.platform === ""
  //     ) {
  //       formErrorObj["Platform_isEmpty"][index] = "Please Select Platform";
  //     }

  //     // if (input.file.length <= 0) {
  //     //   formErrorObj["File_isEmpty"][index] = "Please Select file";
  //     // }

  //     if (
  //       input.title == undefined ||
  //       input.title == null ||
  //       input.title.trim() == ""
  //     ) {
  //       formErrorObj["title_isEmpty"][index] = "Title Cannot Be Empty";
  //     }
  //     if (
  //       input.description == undefined ||
  //       input.description == null ||
  //       input.description.trim() == ""
  //     ) {
  //       formErrorObj["description_isEmpty"][index] =
  //         "Description Cannot Be Empty";
  //     }
  //     // if (
  //     //   input.keywords == undefined ||
  //     //   input.keywords == null ||
  //     //   input.keywords.trim() == ""
  //     // ) {
  //     //   formErrorObj["keywords_isEmpty"][index] = "Keywords Cannot Be Empty";
  //     // }
  //   });

  //   setFormErrors(formErrorObj);
  // };

  const checkArraysEquality = (arr) => {
    return new Set(arr).size === arr.length;
  };

  const onClickFunctionWhoCanSee = async (event, action) => {
    if (action === "Submit") {
      // const checkAllTitles = checkArraysEquality(
      //   inputFields.map((et) =>
      //     et.title.toLowerCase().replace(/\s+/g, " ").trim()
      //   )
      // );
      // const checkAllKeyword = checkArraysEquality(
      //   inputFields.map((et) =>
      //     et.keywords.toLowerCase().replace(/\s+/g, " ").trim()
      //   )
      // );

      // if (!checkAllTitles) {
      //   notify(1, "All title's can not be same.");
      // } else if (!checkAllKeyword) {
      //   notify(1, "All Keyword's can not be same.");
      // } else {

      await checkValidationsWhoCanSee();

      const isEmpty = await Object.values(formErrorObj).every(
        (x) => x === null || x === "" || x === undefined
      );
      if (isEmpty) {
        CloseWhoCanSeeModal();
        setLoading(true);
        let newHashtagArray = [];

        if (!editMode) {
          if (hashtagArray?.length > 0) {
            let elementsWithoutId = hashtagArray.filter(
              (hashtag) => typeof hashtag.value !== "number"
            );
            let elementsWithId = hashtagArray.filter(
              (hashtag) => typeof hashtag.value === "number"
            );

            elementsWithoutId = elementsWithoutId.filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.value === value.value)
            );
            //Insert hashtags without ids in master
            if (elementsWithoutId.length > 0) {
              let requestParams = {
                hashtagArray: elementsWithoutId,
                userId: getFromEncLocalStorage("userId"),
                createdDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
              };
              const resp = await APICall(
                insertNewGeneratedHashtagsInMaster,
                requestParams,
                "POST"
              );

              if (resp) {
                if(resp.message && resp.message.toLowerCase().includes('duplicate')){
                  notify(1, resp.message);
                  return
                }
                newHashtagArray = [...resp.data, ...elementsWithId];
              }
            } else {
              newHashtagArray = [...elementsWithId];
            }
          }
        }

        let Id = 0;
        let requestParams = {
          Id: Id,
          inputFields: inputFields,
          HashTag: newHashtagArray.map((a) => a.value).toString(),
          UserTypeId: userTypeId,
          CoeWhoCanSee: coeWhoCanSee,
          UserName:
            getFromEncLocalStorage("firstname") +
            " " +
            getFromEncLocalStorage("lastname"),
          NameOfPosition: getFromEncLocalStorage("nameofposition"),
          GlobalFDPDStatus: globalFDPDStatus,
          FolderId: folderId,
          TagUser: tagUser,
          CreatedDate: moment(new Date()).format("yyyy-MM-DD HH:mm:ss"),
          UserId: getFromEncLocalStorage("userId"), //UserId
        };

        await UploadFileTillEndRecursiveFun(requestParams);

        setLoading(false);
      }
      // }
    } else if (action === "Reset") {
      resetWhoCanSee();
    } else if (action === "Cancel") {
      CloseWhoCanSeeModal();
    }
  };

  const uploadFile = async (files, isAudio, type) => {
    let fileData = new FormData();
    fileData.append("file", files.blob);
    // console.log(fileData);
    let container = isAudio ? "audios" : "knowledge";
    setLoading(true);
    let resp = await CreateKnowledgeService.fileUpload(fileData, container);
    // console.log(resp);
    if (resp.status.toLowerCase() == "success") {
      return { uploadedFileName: resp.result[0], attachmentFileType: type };
    } else if (resp.status.toLowerCase() == "error") {
      if (resp.message.toLowerCase() == "invalid file format") {
        notify(1, "Invalid File format");
      } else {
        notify(1, "An error occurred while uploading the file. Please try again");
      }
    }
    setLoading(false);
  };

  const uploadVideoTrans = async (newFile) => {
    setLoading(true);
    const knowledgeData = new FormData();
    knowledgeData.append("", newFile.blob);
    let resp = await CreateKnowledgeService.uploadVideo(
      firstToken,
      knowledgeData,
      newFile.name
    );
    if (resp) {
      let { id } = resp;
      let details = await getDetails(firstToken,newFile.name, id);
      setProgress(false);
      const { thumbnailId, transcriptionData } = details;
      return {
        videoId: id,
        thumbnailId: thumbnailId,
        transcriptionData: transcriptionData,
      };
    } else {
      notify(1, "An error occurred while selecting the video file. Please try again");
    }
    setLoading(false);
  };

  const getDetails = async (firstToken,FileName, id) => {
    setProgress(true);
    let resp = await getVideoUploadProgress(firstToken, FileName, id);

    const waitUntilVideoIsUploadedFunObj = await waitUntilVideoIsUploadedFun(
      firstToken,
      FileName,
      id
    );

    if (waitUntilVideoIsUploadedFunObj.isCompleted) {
      let thumbnailId = resp?.results[0]?.thumbnailId;
      let transcriptionData = await getTranscriptionData(id);
      return { thumbnailId: thumbnailId, transcriptionData: transcriptionData };
    }
    return null;
  };

  const getVideoUploadProgress = async (firstToken, FileName, id) => {
    // let resp = await CreateKnowledgeService.getVideoDetails(firstToken, id);
    let resp = await CreateKnowledgeService.getVideoDetails1(firstToken, FileName, id);
    return resp;
  };

  const waitUntilVideoIsUploadedFun = async (firstToken, FileName, id) => {
    try {
      let resp = await getVideoUploadProgress(firstToken,FileName, id);
      while (resp.results[0].processingProgress != "100%") {
        await sleep(3000);
        resp = await getVideoUploadProgress(firstToken,FileName, id);
        let status = parseInt(resp.results[0].processingProgress);
        setProgStatus(status);
      }
      return { isCompleted: true };
    } catch (err) {
      return { isCompleted: false, error: err };
    }
  };

  const getTranscriptionData = async (id) => {
    let tok = await CreateKnowledgeService.getVideoToken(id);
    if (tok) {
      let res = await CreateKnowledgeService.getTranscription(id, tok);
      if (res) {
        let ds = {
          transcript: res.videos[0].insights.transcript,
        };
        return JSON.stringify(ds);
      }
      setProgress(false);
    }
  };


  async function readyForUploadFile(file) {
    // Asynchronous operation to upload a file using network request
    let { type } = file;
    let strarray = type.split("/");
    let strng = strarray[0];
    if (strng === "video") {
      const { videoId, thumbnailId, transcriptionData } =
        await uploadVideoTrans(file);
      return {
        attachmentFileType: type,
        videoId: videoId,
        thumbnailId: thumbnailId,
        transcriptionData: transcriptionData,
      };
    } else if (strng === "audio") {
      const { videoId, thumbnailId, transcriptionData } =
        await uploadVideoTrans(file);
      const { uploadedFileName, attachmentFileType } = await uploadFile(
        file,
        true,
        type
      );
      return {
        videoId: "",
        thumbnailId: "",
        transcriptionData: "",
        uploadedFileName: uploadedFileName,
        attachmentFileType: attachmentFileType,
      };
    } else {
      return uploadFile(file, false, type);
    }
  }

  async function UploadFileTillEndRecursiveFun(data) {
    let res = [];
    let ids = await APICall(insertUpdateKCBulkUpload, data, "POST");
    if (ids?.data?.length > 0) {
      let ErrorSuccess = 1;
      for (let index = 0; index < ids?.data?.length; index++) {
        if (ids?.data?.[index] == null) {
          continue;
        }

        if (ids?.data[index].length > 0) {
          for (let j_index = 0; j_index < ids?.data[index]?.length; j_index++) {
            let requestparam = [];
            let element = "";
            let description = data.inputFields[index].description;
            let title = data.inputFields[index].title;
            let keywords = data.inputFields[index].keywords;
            let platform = data.inputFields[index].platform;
            let aggregate = data.inputFields[index].aggregate;
            let bulkUploadStatus = data.inputFields[index].bulkUploadStatus;
            let coe = data.inputFields[index].coe;
            let CoeWhoCanSee = data.CoeWhoCanSee;
            let CreatedDate = data.CreatedDate;
            let FolderId = data.FolderId;
            let GlobalFDPDStatus = data.GlobalFDPDStatus;
            let HashTag = data.HashTag;
            let Id = data.Id;
            let NameOfPosition = data.NameOfPosition;
            let TagUser = data.TagUser;
            let UserId = data.UserId;
            let UserName = data.UserName;
            let UserTypeId = data.UserTypeId;

            try {
              element = await readyForUploadFile(
                data?.inputFields[index]?.file[j_index]
              );
            } catch (error) {
              ErrorSuccess = 2;
            }

            requestparam = {
              CoeWhoCanSee: CoeWhoCanSee,
              CreatedDate: CreatedDate,
              FolderId: FolderId,
              GlobalFDPDStatus: GlobalFDPDStatus,
              HashTag: HashTag,
              Id: Id,
              NameOfPosition: NameOfPosition,
              TagUser: TagUser,
              UserId: UserId,
              UserName: UserName,
              UserTypeId: UserTypeId,
              checkbulkUploadStatus: bulkUploadStatus,
              inputFields: [
                {
                  description: description,
                  title: title,
                  keywords: keywords,
                  platform: platform,
                  aggregate: aggregate,
                  coe: coe,
                  fileIds: [{ id: ids?.data?.[index]?.[j_index] }],
                  file: [
                    {
                      bulkUploadStatus: ErrorSuccess,
                      attachmentFileType: element?.attachmentFileType,
                      uploadedFileName: element?.uploadedFileName,
                      videoId: element?.videoId,
                      thumbnailId: element?.thumbnailId,
                      transcriptionData: element?.transcriptionData,
                    },
                  ],
                },
              ],
            };
            let insertedData = await APICall(
              insertUpdateKCBulkUpload,
              requestparam,
              "POST"
            );
            res.push(insertedData);
          }
        }
      }

      let checkStatus = false;
      let errorMessage = "";
      for (let index = 0; index < res?.length; index++) {
        if (
          res?.message?.toUpperCase() == "ok".toUpperCase() ||
          res?.[index]?.message.toUpperCase() == "ok".toUpperCase()
        ) {
          checkStatus = true;
        } else {
          checkStatus = false;
          errorMessage = res?.data[index]?.err || res?.[index]?.err;
        }
      }

      if (ErrorSuccess == 2) {
        notify(1, errorMessage);
        history.push({ pathname: "/bulk-upload-document" });
      } else {
        if (checkStatus) {
          notify(0, saveRecordMsg);
          history.push({ pathname: "/bulk-upload-document" });
        } else {
          notify(1, errorMessage);
          history.push({ pathname: "/bulk-upload-document" });
        }
      }
    } else {
      notify(1, ids?.err);
    }
  }

  const checkValidationsWhoCanSee = async () => {
    var objError = {};
    if (!globalFDPDStatus) {
      if (userTypeId.length <= 0) {
        objError["Usertypeid_isEmpty"] = "Please Select User";
      }
      if (coeWhoCanSee && coeWhoCanSee.length <= 0) {
        objError["coewhocansee_isEmpty"] = "Please Select COE";
      }
    }
    // if (hashtagArray.length <= 0) {
    //   objError["Hashtag_isEmpty"] = "Please Select Hash Tag";
    // }

    // if (tagUser && tagUser.length <= 0) {
    //   objError["taguser_isEmpty"] = "Please Select Tag Users";
    // }

    formErrorObj = objError;
    await setFormErrors(objError);
  };

  const resetWhoCanSee = () => {
    setHashTag("");
    setUserTypeId("");
    setCoeWhoCanSee([]);
    setTagUser([]);
    setFormErrors({});
    formErrorObj = {};
  };

  const selectOnChangeWhoCanSee = (event, field) => {
    var error = undefined;
    var setError = "";
    var FieldName = "";
    if (field === "coewhocansee") {
      setCoeWhoCanSee(event);
      setError = "coewhocansee";
      FieldName = "COE";
    }
    if (field === "taguser") {
      setTagUser(event);
      setError = "taguser";
      FieldName = "Tag Users";
    }
    if (field === "usertypeid") {
      setUserTypeId(event);
      setError = "usertypeid";
      FieldName = "User type id";
    }

    // if (event && event.length <= 0) {
    //   error = "Please Select " + FieldName;
    // }

    // setFormErrors((preState) => ({
    //   ...preState,
    //   [setError.replaceAll(" ", "") + "_isEmpty"]: error,
    // }));
  };

  const onSelectChange = (event, controlName) => {
    if (controlName === "hashtag") {
      let array = [...event];

      setHashtagsArray(array);
    }
    // if (controlName === "users") {
    //   let array = [...usersArray, ...event];
    //   setUserArray(array);
    // }
    // if (controlName === "tagusers") {
    //   let array = [...tagusersArray, ...event];
    //   setTagUserArray(array);
    // }
  };

  // const removeTag = (hashtagArr, id) => {
  //   let tempArray = hashtagArr;
  //   tempArray = tempArray.filter(function (obj) {
  //     return obj.value !== id;
  //   });
  //   setHashtagsArray(tempArray);
  // };
  const getHashTags = async (event, cb) => {
    if (event.length >= 3) {
      let requestParams = {
        searchText: event,
      };
      const resp = await APICall(
        getHashtagsAutoComplete,
        requestParams,
        "POST"
      );
      if (resp.data.length > 0) {
        //console.log(resp.data);
        cb(resp.data);
      } else {
        cb([]);
      }
    }
  };

  return (
    <>
      <Main active={"bulk_upload_document"} removeContainer={true}>
        <Loadspinner filename="KCBulkUploadDocument.js" isLoading={isLoading} isMiddle="false" />
        <div className="eventGalleryEdit">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-6">
                <h4 style={{ paddingLeft: "5px" }}>
                  Knowledge Creation Bulk Upload
                </h4>
              </div>
              <div className="col-md-6" style={{ padding: "0% 2% 0% 0%" }}>
                <div
                  className="float-right col-sm-offset-2"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  {inputFields.length > 4 ? (
                    ""
                  ) : (
                    <button
                      className="btn btn-warning"
                      type="button"
                      disabled={editMode ? true : false}
                      onClick={() => {
                        if (!editMode) {
                          addFields();
                        }
                      }}
                    >
                      + Add
                    </button>
                  )}
                </div>
              </div>
              <div
                className="d-flex align-items-center justify-space-between"
                style={{
                  background: "#e61636",
                  padding: "10px 20px 10px 10px",
                  color: "white",
                  width: "100%",
                }}
              >
                <div className="col-lg-8" style={{ paddingLeft: "5px" }}>
                  {FolderName}
                </div>
              </div>
            </div>
          </div>

          <div>
            {inputFields.map((input, index) => {
              let bulkUploadStatuss =
                input.bulkUploadStatus == 0 ||
                input.bulkUploadStatus == 2 ||
                input.bulkUploadStatus == null;
              let bulkUploadStatusswithoutnull =
                input.bulkUploadStatus == 0 || input.bulkUploadStatus == 2;
              return (
                <div
                  className="col-lg-12 col-md-12 mt-3"
                  key={"bulk_upload_row_" + index}
                >
                  <div className="row" style={{ padding: "0px 15px 0px 15px" }}>
                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <FormLabel value="COE" />
                        {/* <sup>*</sup> */}
                        <SelectForm
                          options={coeOptions}
                          placeholder="Select COE"
                          isDisabled={editMode ? true : false}
                          value={input.coe}
                          name="coe"
                          onChange={(event) =>
                            selectOnChange(event, index, "coe")
                          }
                          isMulti={false}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <ErrorLabel
                          value={formErrors["COE_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <FormLabel value="Platform" />
                        {/* <sup>*</sup> */}
                        <SelectForm
                          options={platformOptions}
                          placeholder="Select Platform"
                          isDisabled={editMode ? true : false}
                          value={input.platform}
                          name="platform"
                          onChange={(event) =>
                            selectOnChange(event, index, "platform")
                          }
                          isMulti={false}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <ErrorLabel
                          value={formErrors["Platform_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <FormLabel value="Aggregate" />
                        {/* <sup>*</sup> */}
                        <SelectForm
                          options={aggregateOptions}
                          placeholder="Select Aggregate"
                          isDisabled={editMode ? true : false}
                          value={input.aggregate}
                          name="aggregate"
                          onChange={(event) =>
                            selectOnChange(event, index, "aggregate")
                          }
                          isMulti={false}
                          noIndicator={false}
                          noSeparator={false}
                        />
                        <ErrorLabel
                          value={formErrors["Aggregate_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <FormLabel value="Title" />
                        {/* <sup>*</sup> */}
                        <InputForm
                          className="form-control form-control-sm"
                          placeholder={"Title"}
                          isDisabled={editMode ? true : false}
                          textArea={false}
                          value={input.title}
                          name="title"
                          onChange={(e) => handleFormChange(e, index)}
                        />
                        <ErrorLabel
                          value={formErrors["title_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <FormLabel value="Description" />
                        {/* <sup>*</sup> */}
                        <InputForm
                          className="form-control form-control-sm"
                          placeholder={"Description"}
                          isDisabled={editMode ? true : false}
                          textArea={true}
                          value={input.description}
                          name="description"
                          onChange={(e) => handleFormChange(e, index)}
                        />
                        <ErrorLabel
                          value={formErrors["description_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-sm-4 col-xs-4 ">
                      <div className="form-group">
                        <FormLabel value="Keywords" />
                        {/* <sup>*</sup> */}
                        <InputForm
                          className="form-control form-control-sm"
                          placeholder={"Keywords"}
                          isDisabled={editMode ? true : false}
                          textArea={false}
                          value={input.keywords}
                          name="keywords"
                          onChange={(e) => handleFormChange(e, index)}
                        />
                        <ErrorLabel
                          value={formErrors["keywords_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-6 col-sm-6 col-xs-6 ">
                      <div className="row bulk-upload-card-row">
                        <label className="form-check-label">
                          Upload File
                          {/* <sup>*</sup> */}
                        </label>

                        <div
                          className="drop-container"
                          style={{
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            textAlign: "center",
                            margin: 0,
                            height: "60px",
                            border: "2px dashed #ced4da",
                          }}
                        >
                          <div className="col-1">
                            <img
                              src={images.upload}
                              className="img-responsive"
                              width="30px"
                            />
                          </div>
                          <div className="col-8 message">
                            Attach Files(Documents, Images, Audios & Video
                            files)
                          </div>
                          <div className="col-3">
                            <InputForm
                              type="file"
                              name={`row_${index}`}
                              data-index={index}
                              id={`row_${index}`}
                              isDisabled={bulkUploadStatuss ? false : true}
                              hidden
                              multiple={
                                bulkUploadStatusswithoutnull ? false : true
                              }
                              ref={inputFileRef}
                              onChange={(event) => {
                                fileSelect(event, index, "file");
                              }}
                            />
                            <label
                              style={{ width: "100%" }}
                              htmlFor={`row_${index}`}
                            >
                              <a
                                variant="contained"
                                component="span"
                                style={{
                                  width: "100%",
                                  textDecoration: "underline",
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                disabled={isLoading}
                              >
                                Choose File
                              </a>
                            </label>
                          </div>
                        </div>
                        <ErrorLabel
                          value={formErrors["File_isEmpty"]?.[index]}
                        />
                      </div>
                    </div>

                    <div className="col-lg-2 col-sm-2 col-xs-2 mt-4">
                      {enableSubmit ? (
                        ""
                      ) : (
                        <button
                          style={{ margin: "-15px -14px -32px -9px" }}
                          className="btn-reset btn-secondary btn btn-primary"
                          type="button"
                          onClick={() => {
                            removeFields(index);
                          }}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                    {input.bulkUploadStatus != null ? (
                      <div className="col-lg-2 col-sm-2 col-xs-2 mt-4">
                        <button
                          style={{
                            margin: "-15px -14px -32px -9px",
                            cursor: "context-menu",
                          }}
                          className={`${bulkUploadStatuss
                            ? "btn-reset btn-secondary btn btn-danger"
                            : "btn-reset btn-secondary btn btn-success"
                            }`}
                          type="button"
                        >
                          {bulkUploadStatuss ? "Unsuccessful" : "Successful"}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="row bulk-upload-card-row">
                      <div className="col-12 ">
                        {/* <span>{input.file}</span> */}

                        <div className="row">
                          {input?.file?.map((value, index2) => {
                            //return (value?.attachmentFileType && !value?.attachmentFileType?.startsWith("image") && value?.file) || (value?.videoId) ? (
                            return (
                              <ShowAttachment
                                key={index2}
                                editMode={bulkUploadStatuss ? false : true}
                                aType={value?.attachmentFileType}
                                attachment={
                                  value?.file || value || value?.newfile
                                }
                                videoId={value?.videoId}
                                thumbnailId={value?.thumbnailId}
                                fIdx={index2}
                                index={index}
                                setFileToBeDeleted={setFileToBeDeleted}
                                setShowDeleteConfirmationModal={
                                  setShowDeleteConfirmationModal
                                }
                              />
                            );
                          })}

                          {/* {checkIsUploadedFile ? null : (input?.attachmentFileType !==
                              null &&
                              input?.file !== null) ||
                            (input?.videoId != null && input?.videoId != "") ? (
                            <Card
                              key={index}
                              className="col-lg-2 col-sm-2 col-xs-2"
                              style={{ top: "15px" }}
                            >
                              <ShowAttachment
                                aType={input?.attachmentFileType}
                                attachment={input?.file}
                                videoId={input?.videoId}
                                thumbnailId={input?.thumbnailId}
                              />
                            </Card>
                          ) : null} */}

                          {/* {checkIsUploadedFile
                            ? input?.file?.map((file, fIdx) => {
                              if (file?.attachmentFileType && file?.attachmentFileType?.startsWith("image")) {
                                    return (
                                      <Card
                                        key={`img${fIdx}`}
                                    className="col-2 imgCard"
                                        style={{ top: "15px" }}
                                      >
                                        <Card.Img
                                          variant="top"
                                          src={file?.localUrl}
                                          className="gridImage"
                                        />
                                        <Card.Body className="imgCardBody">
                                          <div className="row my-1">
                                            <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
                                              <Card.Text>
                                                {file?.name ||
                                                  file?.azureFileName}
                                              </Card.Text>
                                            </div>
                                            <div className="col-lg-2 col-sm-2 col-xs-2">
                                              <Button
                                                variant="outline-light"
                                                size="sm"
                                              >
                                                <Image
                                                  src={del}
                                                  className="delBtn"
                                                  onClick={() => {
                                                    setFileToBeDeleted({
                                                      file: file,
                                                      index: index,
                                                      input: "file",
                                                    });
                                                    setShowDeleteConfirmationModal(
                                                      true
                                                    );
                                                  }}
                                                />
                                              </Button>
                                            </div>
                                          </div>
                                        </Card.Body>
                                      </Card>
                                    );
                                  }
                              return null;
                              })
                            : null} */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                </div>
              );
            })}
          </div>
          <div className="col-lg-12 col-md-12 mt-3">
            <div className="row">
              <div className="col-lg-11 col-md-11" style={{ width: "97%" }}>
                <div className="float-right">
                  {inputFields.length > 0 ? (
                    enableSubmit ? (
                      <AccessDetailButton
                        onClick={(e) => onClickFunctionForm(e, "Submit")}
                      />
                    ) : (
                      <SubmitButton
                        onClick={(e) => onClickFunctionForm(e, "Submit")}
                      />
                    )
                  ) : (
                    ""
                  )}
                  <CancelButton
                    onClick={(e) => onClickFunctionForm(e, "Cancel")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          disablePortal
          disableEnforceFocus
          disableAutoFocus
          open={isProgress}
          style={{ background: "transparent" }}
        >
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
            }}
          >
            <CircularProgressWithLabel
              value={Number.isNaN(progressStatus) ? 0 : progressStatus}
              style={{ width: "100px" }}
            />
            <p style={{ margin: "25px", color: "white" }}>Uploading Video</p>
          </div>
        </Modal>

        <Modal
          open={showWhoCanSeeOpenModal}
          onClose={CloseWhoCanSeeModal}
          className="justify-space-around modal-dialog modal-lg modal-dialog-centered"
        >
          <div className="modal-content3" style={{ borderRadius: "25px" }}>
            <div className="modal-body">
              <div className="col-lg-12 col-md-12">
                <div className="row rowMargin">
                  <div className="col-lg-4 col-sm-4 col-xs-4">
                    <div className="form-group">
                      <FormLabel value="Global FDPD"></FormLabel>
                      {/* <sup>*</sup> */}
                      <div className="custom-checkbox">
                        <input
                          disabled={editMode ? true : false}
                          type="checkbox"
                          onChange={(e) => {
                            setGlobalFDPDStatus(e.target.checked);
                          }}
                          name="isActive"
                          checked={globalFDPDStatus}
                          className="isActive"
                          autoComplete={CommonConstants.autoCompleteInput}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12">
                <div className="row rowMargin">
                  <div className="col-lg-6 col-sm-6 col-xs-6">
                    <div className="form-group">
                      <FormLabel value="Who Can See This Post" />
                      {globalFDPDStatus ? "" : <sup>*</sup>}
                      <SelectForm
                        options={coeOptions}
                        placeholder="Select COE"
                        isDisabled={globalFDPDStatus ? true : false}
                        value={coeWhoCanSee}
                        name="coe"
                        onChange={(event) =>
                          selectOnChangeWhoCanSee(event, "coewhocansee")
                        }
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                      />
                      <ErrorLabel value={formErrors["coewhocansee_isEmpty"]} />
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 col-xs-6">
                    <div className="form-group">
                      <FormLabel value="Users"></FormLabel>
                      {globalFDPDStatus ? "" : <sup>*</sup>}
                      <SelectForm
                        options={tagUserOptions}
                        placeholder="User (type token id)"
                        isDisabled={globalFDPDStatus ? true : false}
                        value={userTypeId}
                        name="userTypeId"
                        onChange={(event) =>
                          selectOnChangeWhoCanSee(event, "usertypeid")
                        }
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                      />
                      <ErrorLabel value={formErrors["Usertypeid_isEmpty"]} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12">
                <div className="row rowMargin">
                  <div className="col-lg-6 col-sm-6 col-xs-6">
                    <div className="form-group">
                      <FormLabel value="Hash Tag"></FormLabel>
                      {/* <sup>*</sup> */}
                      <SelectFormCreatableV2
                        async
                        options={(e, callback) => getHashTags(e, callback)}
                        placeholder="Hastags"
                        // defaultOptions={defaultHastags}
                        isDisabled={editMode ? true : false}
                        getOptionLabel={(option) => `#${option.label}`}
                        value={hashtagArray}
                        onChange={(e) => onSelectChange(e, "hashtag")}
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                      />
                      <ErrorLabel value={formErrors["Hashtag_isEmpty"]} />
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-6 col-xs-6">
                    <div className="form-group">
                      <FormLabel value="Tag User" />
                      {/* <sup>*</sup> */}
                      <SelectForm
                        options={tagUserOptions}
                        placeholder="Select Tag User"
                        isDisabled={editMode ? true : false}
                        value={tagUser}
                        name="taguser"
                        onChange={(event) =>
                          selectOnChangeWhoCanSee(event, "taguser")
                        }
                        isMulti={true}
                        noIndicator={false}
                        noSeparator={false}
                      />
                      <ErrorLabel value={formErrors["taguser_isEmpty"]} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 mt-3">
                <div className="row">
                  <div className="col-lg-11 col-md-11" style={{ width: "99%" }}>
                    <div className="float-right">
                      {enableSubmit ? (
                        ""
                      ) : (
                        <>
                          <SubmitButton
                            onClick={(e) =>
                              onClickFunctionWhoCanSee(e, "Submit")
                            }
                          />

                          <ResetButton
                            onClick={(e) =>
                              onClickFunctionWhoCanSee(e, "Reset")
                            }
                          />
                        </>
                      )}
                      <CancelButton
                        onClick={(e) => onClickFunctionWhoCanSee(e, "Cancel")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <DeleteDialogueBox
          open={showDeleteConfirmationModal}
          close={() => setShowDeleteConfirmationModal(false)}
          cancel={() => {
            setFileToBeDeleted({});
            setShowDeleteConfirmationModal(false);
          }}
          deleteImage={() => deleteImage(fileToBeDeleted)}
        />
        {/* {inputFields.map((val,index) => {
              return (
                  <input
                      type="file"
                      key={index}
                      data-index={index}
                      onChange={(event) => {
                        
                          const inputIndex = Number(event.target.dataset.index);
                          console.log("Changed input index:", inputIndex);
                      }}
                  />
              )
          })} */}
      </Main>
    </>
  );
};

export default KCBulkUploadDocument;
